<template>
  <div class="classical-wrapper" v-if="dataDone">
    <h1 class="script-title">{{title}}</h1>
    <div class="script-content">
      <div class="script-item">
        <h3>主治</h3>
        <div class="content">{{indications}}</div>
      </div>
      <div class="script-item">
        <h3>功用</h3>
        <div class="content">{{effect}}</div>
      </div>
      <div class="script-item">
        <h3>药材剂量（现代）</h3>
        <div class="content">{{scriptString}}</div>
      </div>
    </div>
    <div class="script-control">
      <button class="save-button" @click="saveAsTemplate" v-if="userInfo.doctor_type == 1">保存为处方模板</button>
      <button class="back-button" @click="back">返回</button>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .classical-wrapper{
    min-height: 100vh;
    background: #FAFAFA;
    padding: 10px 0 0 24px;
    .script-title{
      padding: 12px 0;
      font-size: 20px;
      line-height: 26px;
      border-bottom: 1px solid #F3F3F3;
    }
    .script-content{
      padding-top: 24px;
      .script-item{
        margin-bottom: 36px;
        h3{
          position: relative;
          padding-left: 7px;
          font-size: 16px;
          font-weight: normal;
          color: #666;
          line-height: 22px;
          &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 15px;
            background: @xile;
          }
        }
        .content{
          margin-top: 8px;
          font-size: 15px;
          line-height: 21px;
          color: @black;
          padding-right: 24px;
        }
      }
    }
    .script-control{
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 64px;
      background: #FAFAFA;
      padding: 12px 16px;
      button{
        @button-base();
        flex: 1;
        height: 40px;
        &.save-button{
          @button-border();
          background: rgba(54, 104, 166, 0.05);
          margin-right: 15px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        scriptId: this.$route.params.id,
        title: '',
        effect: '',
        indications: '',
        content: [],
      }
    },
    created() {
      this.$root.post('/getClassicalPretDetail', {
        id: this.scriptId
      }).then(data => {
        this.dataDone = true;
        this.title = data.title;
        this.effect = data.effect;
        this.indications = data.indications;
        this.content = data.content || [];
      })
    },
    computed: {
      scriptString() {
        let list = [];
        this.content.forEach(herb => {
          let string = `${herb.name} ${herb.num}${herb.unit || 'g'} ${herb.remark ? '(' + herb.remark + ')' : ''}`;
          list.push(string);
        })
        return list.join('、');
      },
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      saveAsTemplate() {
        this.$router.push({path: '/prescription-edit', query: {id: this.scriptId, type: 'classical'}});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/ClassicalPrescription/detail.vue